export default "__VITE_ASSET__826da23b__"